import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '../../mui-styles-bridge.js';
import { TextField } from '@mui/material';
import {
  getValidationHelperText,
  validatePattern,
} from '../../utils/inputValidation';

const styles = (theme) => ({
  root: {
    width: '100%',
    margin: 'auto',

    backgroundColor: theme.palette.background.paper,
  },
});

class FreeText extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      answer: '',
    };
  }

  componentDidMount() {
    let answer_data = this.props.form.answer_data[this.props.data.key];
    if (answer_data && answer_data.answer) {
      this.setState({
        answer: this.props.form.answer_data[this.props.data.key].answer[0],
      });
    } else {
      if (this.props.data.data && this.props.data.data.toString() && this.state.answer == '') {
        this.setState({ answer: this.props.data.data });
        this.props.getDataFromComponent(
          { text_answer: this.props.data.data },
          this.props.data.key,
          this.props.data.question_text,
          this.props.data.data
        );
      }
      if (
        this.props.data.auto.toString() &&
        !this.props.form.answer_data[this.props.data.key]
      ) {
        this.props.getDataFromComponent(
          { text_answer: this.props.data.auto },
          this.props.data.key,
          this.props.data.question_text,
          this.props.data.data
        );
        this.setState({ answer: this.props.data.auto });
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.data.data != prevProps.data.data) {
      this.props.getDataFromComponent(
        { text_answer: this.props.data.data },
        this.props.data.key,
        this.props.data.question_text,
        this.props.data.data
      );
      this.setState({ answer: this.props.data.data });
    }
  }

  handleOnChange = (event) => {
    this.setState({ answer: event.target.value });
  };

  handleOnBlur = (event) => {
    let text = { text_answer: event.target.value };
    this.props.getDataFromComponent(
      text,
      this.props.data.key,
      this.props.data.question_text,
      this.props.data.data
    );
  };

  doNothing = () => {};
  render() {
    const { classes, data } = this.props;

    try {
      return (
        <div className={classes.root}>
            <TextField
              className={classes.textField}
              fullWidth
              value={this.state.answer || ''}
              disabled={this.props.data.read_only}
              multiline
              minRows={4}
              placeholder={typeof this.props.data.data === 'object' ? this.props.data.data.placeholder : undefined}
              error={
                !validatePattern(this.state.answer, this.props.data.validation)
              }
              helperText={getValidationHelperText(
                this.state.answer,
                this.props.data.validation
              )}
              variant="outlined"
              label={typeof this.props.data.data === 'object' ? this.props.data.data.label : undefined}
              onChange={
                this.props.data.read_only == true
                  ? this.doNothing
                  : this.handleOnChange
              }
              onBlur={
                this.props.data.read_only == true
                  ? this.doNothing
                  : this.handleOnBlur
              }
            />
        </div>
      );
    } catch (e) {
      return <h5>Error encountered</h5>;
    }
  }
}

const mapStateToProps = (state, props) => {
  return {
    form: state.form,
  };
};

const mapDispatchToProps = {};

FreeText.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(FreeText));
